/* eslint-disable indent */
import store from '@/store';

const { 'auth/isTasador': isTasador } = store.getters;

const linkColumns = {
    charge: 'CHARGE',
    documentation: 'DOCUMENTATION',
};

const columnLink = (row, target) => {
    const chargeRoute = { name: 'charge', params: { id: `${row.id}` } };

    if (target === linkColumns.charge) {
        return chargeRoute;
    }

    if (target === linkColumns.documentation) {
        return {
            ...chargeRoute,
            query: {
                activeTab: 1,
            },
        };
    }

    return '#';
};

const valueToYesNo = value => (value ? 'Si' : 'No');

const CHARGE_NUMBER_COLUMN = {
    label: 'Nº Encargo',
    dataKey: 'numero_encargo_formateado',
    width: 115,
    sortable: 'custom',
    isLink: true,
    link: row => columnLink(row, linkColumns.charge),
};

const DOCUMENTATION_COLUMN = {
    label: 'Doc',
    dataKey: 'tiene_documentacion',
    width: 50,
    sortable: 'custom',
    isLink: true,
    link: row => columnLink(row, linkColumns.documentation),
    valueFormatter: valueToYesNo,
};

const tableColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ofi',
        dataKey: 'tasador_nombre',
        sortable: 'custom',
        width: 50,
        align: 'center',

    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Emp',
        dataKey: 'delegacion_nombre',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
        align: 'center',

    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Rev',
        dataKey: 'tasador_revision_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tas Rec',
        sortable: 'custom',
        width: 50,
        dataKey: 'tasador_revision_clave',

    },
    {
        label: 'F. Encargo',
        dataKey: 'fecha_hora_recepcion_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Pob',
        dataKey: 'inmueble_poblacion',
        sortable: 'custom',
        width: 130,
    },
    {
        label: 'Soli',
        dataKey: 'solicitante_nombre',
        minWidth: 60,
        sortable: 'custom',
    },

].map((col) => {
    if (col.dataKey === 'advertencias') {
        return col;
    }


    return { ...col, showOverflowTooltip: true };
});


// Filtro - Altas
export const aStatusColumns = [

    {
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ofi',
        dataKey: 'tasador_nombre',
        sortable: 'custom',
        width: 50,
        align: 'center',

    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Num Ant',
        dataKey: 'inmueble_numantecedente',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Emp',
        dataKey: 'delegacion_nombre',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Solicitante',
        dataKey: 'solicitante_nombre',
        minWidth: 60,
        sortable: 'custom',
    },
    {
        label: 'Zona',
        dataKey: 'zona_nombre',
        width: 100,
        sortable: 'custom',
    },
    /*  {
         label: 'Tas Zon',
         dataKey: 'tasador_zona_clave',
         width: 50,
         sortable: 'custom',
     }, */
    {
        label: 'F. Encargo',
        dataKey: 'fecha_hora_recepcion_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Dirección',
        dataKey: 'inmueble_direccion',
        minWidth: 60,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true, align: 'center' }));

export const noFilterStatusColumns = tableColumns.reduce((acc, item) => {
    if (item.dataKey === 'estado_texto') {
        return [
            ...acc,
            item,
            /* {
                                            label: 'Tas.Vis',
                                            dataKey: 'tasador_encargado_codigo',
                                            width: 90,
                                            sortable: 'custom',
                                          },
                                          {
                                            label: 'Tas.Sal',
                                            dataKey: 'tasador_salidas_codigo',
                                            width: 90,
                                            sortable: 'custom',
                                          },
                                          {
                                            label: 'Tas.Inc',
                                            dataKey: 'tasador_incidencias_codigo',
                                            width: 90,
                                            sortable: 'custom',
                                          },
                                          {
                                            label: 'Tas.Rev',
                                            dataKey: 'tasador_revision_codigo',
                                            width: 92,
                                            sortable: 'custom',
                                          },
                                          {
                                            label: 'Tas.Env',
                                            dataKey: 'tasador_enviar_codigo',
                                            width: 92,
                                            sortable: 'custom',
                                          }, */
        ];
    }
    return [...acc, item];
}, []);


// Filtro - Asig. Visitas
export const bStatusColumns = [
         {
           label: 'Cod.',
           dataKey: 'codigo',
           width: 72,
           sortable: 'custom',
         },
         {
           label: 'A',
           dataKey: 'advertencias',
           width: 32,
         },
         CHARGE_NUMBER_COLUMN,
         {
           label: 'FIN',
           dataKey: 'inmueble_finalidad',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Estado.',
           dataKey: 'estado_texto',
           width: 100,
           sortable: 'custom',
         },
         DOCUMENTATION_COLUMN,
         {
           label: 'Vis Int',
           dataKey: 'visita_exterior_texto',
           width: 60,
           sortable: 'custom',
         },
         {
           label: 'F. Encargo',
           dataKey: 'fecha_hora_recepcion_texto',
           width: 110,
           sortable: 'custom',
         },
         {
           label: 'F. Entrega',
           dataKey: 'fecha_hora_limite_texto',
           width: 110,
           sortable: 'custom',
         },
         {
           label: 'Zona',
           dataKey: 'zona_nombre',
           width: 90,
           sortable: 'custom',
         },
         {
           label: 'Tas Zon',
           dataKey: 'tasador_zona_clave',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Población',
           dataKey: 'inmueble_poblacion',
           minWidth: 110,
           sortable: 'custom',
         },
         {
           label: 'Ant',
           dataKey: 'antecedente_texto',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Num Ant',
           dataKey: 'inmueble_numantecedente',
           width: 120,
           sortable: 'custom',
         },
         {
           label: 'Cli',
           dataKey: 'empresa_cliente_nombre',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Tas Vis',
           dataKey: 'tasador_encargado_codigo',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Tas Sal',
           dataKey: 'tasador_salidas_codigo',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Tas. Inc',
           dataKey: 'tasador_incidencias_codigo',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Tra',
           dataKey: 'tipo_trabajo_clave',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Inm',

           dataKey: 'tipo_inmueble_clave',
           width: 50,
           sortable: 'custom',
         },
         {
           label: 'Sucursal',
           dataKey: 'sucursal',
           width: 100,
           sortable: 'custom',
         },
         {
           label: 'CP',
           dataKey: 'inmueble_codigopostal',
           minWidth: 60,
           sortable: 'custom',
         },
       ].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro  Visitas
export const cStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },

    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',

        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Población',
        dataKey: 'inmueble_poblacion',
        width: 130,
        sortable: 'custom',
    },
    {
        label: 'Dirección',
        dataKey: 'inmueble_direccion',
        minWidth: 60,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Incidencias
export const dStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Nº.Ant',
        dataKey: 'inmueble_numantecedente',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'F. Encargo',
        dataKey: 'fecha_hora_recepcion_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'F.Inc',
        dataKey: 'incidencia_abierta',
        width: 130,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        minWidth: 60,
        sortable: 'custom',
    },

].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Asignación de salidas
export const eStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Datos visita..',
        dataKey: 'visita_formateada',
        width: 140,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Población',
        dataKey: 'inmueble_poblacion',
        minWidth: 110,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Salidas
export const fStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Datos visita',
        dataKey: 'visita_formateada',
        width: 140,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Num Ant',
        dataKey: 'inmueble_numantecedente',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Rev',
        dataKey: 'tasador_revision_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Población',
        dataKey: 'inmueble_poblacion',
        minWidth: 110,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Revisión

export const gStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Num Ant',
        dataKey: 'inmueble_numantecedente',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Rev',
        dataKey: 'tasador_revision_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Población',
        dataKey: 'inmueble_poblacion',
        minWidth: 110,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));

// Filtro - Enviar
export const hStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Ant',
        dataKey: 'antecedente_texto',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Num Ant',
        dataKey: 'inmueble_numantecedente',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Rev',
        dataKey: 'tasador_revision_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tas Rec',
        sortable: 'custom',
        width: 50,
        dataKey: 'tasador_revision_clave',

    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        minWidth: 60,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Terminados
export const iStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 80,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'F.Envio',
        dataKey: 'fecha_hora_envio_texto',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Valor Tas',
        dataKey: 'valoracion_tasacion',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Honor Tas',
        dataKey: 'honorarios_tasacion',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Despl',
        dataKey: 'gastos_desplazamiento',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Fac Neta',
        dataKey: 'facturacion_neta',
        width: 100,
        sortable: 'custom',
    },
    {
        label: '% Fac Neta',
        dataKey: 'facturacion_neta_porcentaje_honorarios',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        minWidth: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Fecha Visado',
        dataKey: 'fecha_visado',
        minWidth: 90,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Retenidos

export const jStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'F. Retenido',
        dataKey: 'fecha_retenido',
        width: 140,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },

    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },

    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        minWidth: 50,
        sortable: 'custom',
    },

].map(col => ({ ...col, showOverflowTooltip: true }));

// Filtro - Visados
export const kStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 80,
        sortable: 'custom',
    },
    {
        label: 'Valor Tas',
        dataKey: 'valoracion_tasacion',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Honor Tas',
        dataKey: 'honorarios_tasacion',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Despl',
        dataKey: 'gastos_desplazamiento',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Fac Neta',
        dataKey: 'facturacion_neta',
        width: 100,
        sortable: 'custom',
    },
    {
        label: '% Fac Neta',
        dataKey: 'facturacion_neta_porcentaje_honorarios',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
        align: 'center',

    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },

    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Fecha Visado',
        dataKey: 'fecha_visado',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Fecha facturado',
        dataKey: 'facturacion_neta_fecha',
        minWidth: 110,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - Facturado
export const mStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Valor Tas',
        dataKey: 'valoracion_tasacion',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Honor Tas',
        dataKey: 'honorarios_tasacion',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Despl',
        dataKey: 'gastos_desplazamiento',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Fac Neta',
        dataKey: 'facturacion_neta',
        width: 100,
        sortable: 'custom',
    },
    {
        label: '% Fac Neta',
        dataKey: 'facturacion_neta_porcentaje_honorarios',
        width: 70,
        sortable: 'custom',
    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },
    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tas Rec',
        sortable: 'custom',
        width: 50,
        dataKey: 'tasador_revision_clave',

    },
    {
        label: 'Com',
        sortable: 'custom',
        width: 50,
        dataKey: 'comercial_nombre',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Fecha facturado',
        dataKey: 'facturacion_neta_fecha',
        minWidth: 170,
        sortable: 'custom',
    },
].filter(col => !isTasador || col.dataKey !== 'facturacion_neta').map(col => ({ ...col, showOverflowTooltip: true }));

// Filtro - Reclamación

export const nStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'Fecha Rec',
        dataKey: 'fecha_revision',
        width: 150,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },

    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },

    {
        label: 'Tas Rec',
        sortable: 'custom',
        width: 50,
        dataKey: 'tasador_revision_clave',

    },
    {
        label: 'Exp',
        dataKey: 'expediente',
        width: 125,
        sortable: 'custom',
    },

    {
        label: 'Valtin',
        dataKey: 'num_valoracion',
        width: 90,
        sortable: 'custom',
    },
    {
        label: 'Cli',
        dataKey: 'empresa_cliente_nombre',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Ret',
        width: 50,
        sortable: 'custom',
        dataKey: 'tasador_retenido_codigo',
    },
    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        minWidth: 50,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));


// Filtro - En ruta
export const lStatusColumns = [{
        label: 'Cod.',
        dataKey: 'codigo',
        width: 72,
        sortable: 'custom',
    },
    {
        label: 'A',
        dataKey: 'advertencias',
        width: 32,
    },
    CHARGE_NUMBER_COLUMN,
    {
        label: 'FIN',
        dataKey: 'inmueble_finalidad',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Estado.',
        dataKey: 'estado_texto',
        width: 120,
        sortable: 'custom',
    },
    {
        label: 'Datos visita',
        dataKey: 'visita_formateada',
        width: 140,
        sortable: 'custom',
    },
    {
        label: 'F. Entrega',
        dataKey: 'fecha_hora_limite_texto',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Tas Vis',
        dataKey: 'tasador_encargado_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas Sal',
        dataKey: 'tasador_salidas_codigo',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Tas. Inc',
        dataKey: 'tasador_incidencias_codigo',
        width: 50,
        sortable: 'custom',
    },
    DOCUMENTATION_COLUMN,
    {
        label: 'Vis. Int',
        dataKey: 'visita_exterior_texto',
        width: 50,
        sortable: 'custom',
    },

    {
        label: 'Cli',
        dataKey: 'nombre_empresa_cliente',
        width: 60,
        sortable: 'custom',
    },

    {
        label: 'Tra',
        dataKey: 'tipo_trabajo_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Inm',
        dataKey: 'tipo_inmueble_clave',
        width: 50,
        sortable: 'custom',
    },
    {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 100,
        sortable: 'custom',
    },
    {
        label: 'CP',
        dataKey: 'inmueble_codigopostal',
        width: 60,
        sortable: 'custom',
    },
    {
        label: 'Población',
        dataKey: 'inmueble_poblacion',
        width: 110,
        sortable: 'custom',
    },
    {
        label: 'Dirección',
        dataKey: 'inmueble_direccion',
        minWidth: 60,
        sortable: 'custom',
    },
].map(col => ({ ...col, showOverflowTooltip: true }));

/* export const assessorsTableColumns = [
  {
    label: 'Tas',
    dataKey: 'clave',
    minWidth: 55,
    sortable: 'custom',
  },
  {
    label: 'ENC',
    dataKey: 'numero_encargos',
    width: 48,
  },
  {
    label: 'SAL',
    dataKey: 'numero_encargos_tasador_salida',
    width: 48,
  },
  {
    label: 'INC',
    dataKey: 'numero_encargos_en_incidencia',
    width: 48,
  },
  {
    label: 'VIS',
    dataKey: 'numero_encargos_visitas',
    width: 48,
  },
  {
    label: 'RET',
    dataKey: 'numero_encargos_retenidos',
    width: 48,
  },
  {
    label: 'REV',
    dataKey: 'numero_encargos_revision',
    width: 48,
  },
].map(c => ({ ...c, align: 'center' }));
 */

export const assessorsTableColumns = [{
        label: 'Tas',
        dataKey: 'clave',
        minWidth: 50,
        sortable: 'custom',
    },
    {
        label: 'Vis',
        dataKey: 'numero_encargos_visitas',
        width: 40,
        sortable: 'custom',

    },
    {
        label: 'Rut',
        width: 42,
        dataKey: 'numero_encargos_tasador_ruta',
        sortable: 'custom',

    },
    {
        label: 'Sal',
        dataKey: 'numero_encargos_tasador_salida',
        width: 40,
        sortable: 'custom',

    },
    {
        label: 'Inc',
        dataKey: 'numero_encargos_en_incidencia',
        width: 40,
        sortable: 'custom',

    },
    {
        label: 'Rev',
        dataKey: 'numero_encargos_revision',
        width: 43,
        sortable: 'custom',

    },
    {
        label: 'Ret',
        dataKey: 'numero_encargos_retenidos',
        width: 43,
        sortable: 'custom',
    },
    {
        label: 'Rec',
        dataKey: 'numero_encargos_reclamacion',
        width: 43,
        sortable: 'custom',
    },
    {
        label: 'Tot',
        width: 50,
        sortable: 'custom',
        dataKey: 'numero_encargos',
    },

].map(c => ({ ...c, align: 'center' }));


export const TasadorRoleassessorsTableColumns = [{
        label: 'Tas',
        dataKey: 'clave',
        minWidth: 50,
        sortable: true,
    }].map(c => ({ ...c, align: 'left' }));


export default noFilterStatusColumns;
